/*********************************************************
 *                  Fares Ctrl
 *
 *
 ********************************************************/


"use strict";

angular.module("admin")
	.controller("FaresCtrl", ["$http", "$scope", "toastr", "clients", "ENV","ExploitationService", "FaresService", "Utils", "$uibModal", "AdminClientsService",
		function ($http, $scope, toastr, clients, ENV,ExploitationService, FaresService, Utils, $uibModal, AdminClientsService) {

		$scope.data = {
			clients: clients.data,
		};

		$scope.data.clients = $scope.data.clients.filter(
			c => c.code.indexOf("mobiiti_") !== 0 &&
				c.code.indexOf("technique") !== 0);

		if ($scope.data.clients.length > 0) {
			$scope.selectedClient = $scope.data.clients[0];
		}

		let importUserProfilesModal, importFaresModal, deleteDataFaresModal, deleteProviderFaresModal;

		$scope.openImportUserProfilesModal = function () {
			importUserProfilesModal = Utils.openModal($uibModal, "importUserProfiles.html", $scope);
		};
		$scope.openImportFaresCSVModal = function () {
			importFaresModal = Utils.openModal($uibModal, "importFaresCSV.html", $scope);
		};
		$scope.openImportFaresNetexModal = function () {
			importFaresModal = Utils.openModal($uibModal, "importFaresNetex.html", $scope);
		};
		$scope.openDeleteDataFaresModal = function () {
			deleteDataFaresModal = Utils.openModal($uibModal, "deleteDataFares.html", $scope);
		};
		$scope.openDeleteProviderFaresModal = function () {
			deleteProviderFaresModal = Utils.openModal($uibModal, "deleteProviderFares.html", $scope);
		};

		AdminClientsService.getReferentialIdAndUser().then((referential) => {
			$scope.data.currentReferential = referential;
		});

		$scope.enableButton = function () {
			$scope.data.enableButton = true;
		};

		$scope.importUserProfiles = function (newImportUserProfiles) {
			AdminClientsService.getReferentialName()
				.then((referential) => FaresService.importUserProfiles($scope.data.currentReferential.user, newImportUserProfiles, referential))
				.then(() => {
					toastr.success("Import des profils utilisateurs réussi");
					importUserProfilesModal.close();
				})
				.catch((error) => {
					const data = error.data;
					let errorMessage = "Problème lors de l'import des profils utilisateurs";
					if (data !== undefined && data.message) {
						errorMessage += "\n" + data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
		};

		$scope.importFaresCSV = function (newImportFares) {
			AdminClientsService.getReferentialName()
				.then((referential) => FaresService.importFaresCSV($scope.data.currentReferential.user, newImportFares, referential))
				.then(() => {
					toastr.success("Import des tarifs au format CSV réussi");
					importFaresModal.close();
				})
				.catch((error) => {
					const data = error.data;
					let errorMessage = "Problème lors de l'import des tarifs";
					if (data !== undefined && data.message) {
						errorMessage += "\n" + data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
		};

		$scope.importFaresNetex = function (newImportFares) {
			if (newImportFares.file) {
				$scope.data.loading = true;

				// Appel du service pour envoyer le fichier
				FaresService.importFaresNetex($scope.data.currentReferential.user, newImportFares.file.name, newImportFares, AdminClientsService.getCurrentReferential())
					.then(() => {
						toastr.success("Import des tarifs au format Netex réussi");
						$scope.data.loading = false;
						importFaresModal.close();
					})
					.catch((error) => {
						const data = error.data;
						$scope.data.loading = false;
						let errorMessage = "Problème lors de l'import des tarifs";
						if (data && data.message) {
							errorMessage += "\n" + data.message;
						}
						toastr.error(errorMessage, "Erreur");
					});
			} else {
				toastr.error("Veuillez sélectionner un fichier avant de démarrer l'import.", "Erreur");
			}
		};

		$scope.deleteDataFares = function () {
			FaresService.deleteDataFares($scope.data.currentReferential.user)
				.then(() => {
					toastr.success("Les données du référentiel tarifaire ont été supprimées");
					deleteDataFaresModal.close();
				})
				.catch((error) => {
					const data = error.data;
					let errorMessage = "Problème lors de la suppression du référentiel tarifaire";
					if (data !== undefined && data.message) {
						errorMessage += "\n" + data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
		};

		$scope.deleteProviderFares = function (clientName) {
			FaresService.deleteProviderFares(clientName, $scope.data.currentReferential.user)
				.then(() => {
					toastr.success("Les données du référentiel tarifaire " + $scope.data.currentReferential.user + " ont été supprimées");
					deleteProviderFaresModal.close();
				})
				.catch((error) => {
					const data = error.data;
					let errorMessage = "Problème lors de la suppression du référentiel tarifaire pour : " + $scope.data.currentReferential.user;
					if (data !== undefined && data.message) {
						errorMessage += "\n" + data.message;
					}
					toastr.error(errorMessage, "Erreur");
				});
		};

	}]);

